import { createSlice } from '@reduxjs/toolkit'

const hallSeatingSlice = createSlice({
    name: 'hallSeating',
    initialState: { loading: false, data: null, originalSeating: null },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        loadData() {},
        setData(state, action) {
            const { payload } = action

            if (!payload) {
                return
            }

            state.data = payload
        },
        setOriginalSeating(state, action) {
            const { payload } = action

            if (!payload) return

            state.originalSeating = payload
        },
    },
})

const { actions, reducer } = hallSeatingSlice

export const { setLoading, loadData, setData, setOriginalSeating } = actions

export default reducer
